import { render, staticRenderFns } from "./TagsModal.vue?vue&type=template&id=641b8546&scoped=true&"
import script from "./TagsModal.vue?vue&type=script&lang=js&"
export * from "./TagsModal.vue?vue&type=script&lang=js&"
import style0 from "./TagsModal.vue?vue&type=style&index=0&id=641b8546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b8546",
  null
  
)

export default component.exports